import React from 'react';
import CSS from 'react-css-modules';
import Fade from 'react-reveal/Fade';

import Header from 'app/components/common/Header';

import logo from 'assets/images/chatie_logo.png';
import backgroundWriter from 'assets/images/background_writer2.jpg';

import styles from './style.scss';

class Writer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      recruitmentPeriod: "",
      isDescription: false,
      isHeaderDark: false,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillMount() {
    const now = new Date()
    const month = now.getMonth() + 1
    const endDate = new Date(now.getFullYear(), month, 0).getDate()
    this.setState({ recruitmentPeriod: `${month}/1 ~ ${month}/${endDate}` }) 
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScroll, false);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const { top: descriptionTop } = this.descriptionRef.getBoundingClientRect();
    if (descriptionTop < 300) {
      this.setState({ isDescription: true, isHeaderDark: true });
    } else {
      this.setState({ isHeaderDark: false });
    }
  };

  render() {
    const { isDescription, isHeaderDark } = this.state;
    return (
      <React.Fragment>
        <Header themeDark={isHeaderDark} />
        <div
          styleName="writer"
        >
          <div
            styleName="writer__main"
            style={{
              backgroundImage: `url(${backgroundWriter})`,
            }}
          >
            <Fade>
              <div styleName="writer__main__contents">
                <h4>이야기 풍선 '채티'가</h4>
                <h4>여러분의 소중한 작품을</h4>
                <h4>기다리고 있어요!</h4>
              </div>
            </Fade>
          </div>
          <div styleName="writer__description" ref={(node) => { this.descriptionRef = node; }}>
            <div styleName="section-contribution__contents">
              <Fade when={isDescription}>
                <img styleName="section-contribution__contents__logo" src={logo} alt="로고" />
                <h3 styleName="section-contribution__contents__title">
                  <span>'채팅형 소설'</span> 플랫폼 <span>채티</span>가<br />
                  <span>'채팅형 소설'</span>의 작가를 모집하고 있습니다.
                </h3>
              </Fade>
              <Fade when={isDescription} delay={200}>
                <h4 styleName="section-contribution__contents__term">기간: {this.state.recruitmentPeriod}</h4>
                <h4><span>원고:</span>1화 이상의 채티 파일(원고), 기획안</h4>
                <p>1화 기준 말풍선 <span>150~250개</span> (글자 수 약 1500자~ 2500자)</p>
                <p>채티 오리지널 탭에서 추천, 스릴러, 호러, 로맨스, 드라마 카테고리의<br />작품을 감상하시고 참고해주세요.</p>
                <h4><span>장르:</span>성인 / 팬픽 제외한 모든 장르</h4>
                <h4>
                  <span>투고 방법:</span>
                  검토에 필요한 채티파일과 기획안을 하나의 폴더로 압축하여,<br />
                  [  <span>작가명_작품제목</span>].zip 파일을 <span>content@eineblu.me</span> 메일로 제출
                </h4>
              </Fade>
              <Fade when={isDescription} delay={400}>
                <div
                  styleName="section-contribution__contents__warning"
                >
                  <h5>주의 사항</h5>
                  <p>- 투고 검토는 <span>표절이 아닌 작품</span>, <span>타 플랫폼에 공개되지 않은 신작</span>에 한해 이루어집니다.</p>
                  <p>- 원고는 <span>채티 PC 스튜디오</span>로 작성한 채티파일만 받고 있습니다.</p>
                  <p>&nbsp;&nbsp;(채티 홈페이지 내, 채티 pc스튜디오 가이드 참고)</p>
                  <p>- 투고 작품의 기획은 <span>20화</span> 이내여야 합니다.</p>
                  <p>- 테스트 원고로 내부회의를 통해 면밀히 검토한 뒤 계약 진행 여부를 알려드립니다.</p>
                  <p>&nbsp;&nbsp;<span>(결과는 최대 2주 내로 메일로 전달 드립니다.)</span></p>
                  <p>- 테스트 원고를 2화 이상으로 완성하여 투고해도 테스트비는 <span>고정적으로 2만 원</span>만 지급됩니다.</p>
                  <p>- 재차 테스트 원고 투고 시 테스트비는 중복으로 지급되지 않습니다.</p>
                  <p>- 테스트 원고의 완성도가 높다면 계약 후 <span>정식 연재</span>로 진행될 수 있습니다.</p>
                  <p>&nbsp;&nbsp;<span>(정식 연재 시에는 테스트비와 별도로 원고 MG가 지급됩니다.)</span></p>
                </div>
              </Fade>
              <span styleName="contribution-contact">투고 문의: content@eineblu.me</span>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const Component = CSS(Writer, styles, { allowMultiple: true });

export default Component;



// WEBPACK FOOTER //
// ./src/app/pages/Writer/index.js